import { render } from "./BatchesPanel.vue?vue&type=template&id=53757118&scoped=true"
import script from "./BatchesPanel.vue?vue&type=script&lang=js"
export * from "./BatchesPanel.vue?vue&type=script&lang=js"

import "./BatchesPanel.vue?vue&type=style&index=0&id=53757118&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53757118"]])

export default __exports__